import {getMassGroupSummaries, listProjects} from "../graphql/queries";
import {API, graphqlOperation} from "aws-amplify";

export const FETCH_PROJECT_SUMMARY = "FETCH_PROJECT_SUMMARY";
export const FETCH_PROJECT_LIST = "FETCH_PROJECT_LIST";
export const NEW_PROJECT = "NEW_PROJECT";

export function setProjectSummary(projectSummary) {
    return {
        type: FETCH_PROJECT_SUMMARY,
        ...projectSummary
    }
}

export function setProjects(projects) {
    return {
        type: FETCH_PROJECT_LIST,
        projectsList: projects
    }
}

export function fetchProject(projectId) {

    return (dispatch) => {

        API.graphql(
            graphqlOperation(getMassGroupSummaries, {projectId: projectId})
        ).then(result => {
            const items = result.data.getMassGroupSummaries.items;
            for (let i = 0; i < items.length; i++) {
                const item = JSON.parse(items[i]);
                const structureIds = [];
                const keys = Object.keys(item);
                for (let j = 0; j < keys.length; j++) {
                    if(keys[j].includes("-") && item[keys[j]] > 0) {
                        structureIds.push(keys[j]);
                    }
                }
                items[i] = {
                    massGroup: item.massGroup,
                    structureIds: structureIds,
                    assigned: item.assigned,
                    unassigned: item.unassigned
                };
            }
            return {
                projectId: projectId,
                massGroupSummaries: items
            }
        }).then(
            result => dispatch(setProjectSummary(result))
        ).catch((e) => {
            console.log("There was an error fetching the project summary");
            console.log(e);
        });
    }
}

export function fetchProjectsList() {

    return (dispatch) => {

        API.graphql(
            graphqlOperation(listProjects)
        ).then(result => {

            const projects = result.data.listProjects.items;
            projects.sort((a, b) => {return a.projectName.localeCompare(b.projectName)});
            return projects
        }).then(
            result => dispatch(setProjects(result))
        ).catch((e) => {
            console.log("There was an error fetching the projects list");
            console.log(e);
        });
    }
}

export function createNewProject(newProject) {

    return {
        type: NEW_PROJECT,
        newProject: newProject
    }
}